import { Component, Input, OnInit } from '@angular/core';
import { Notification, SubTitleWrapper } from 'src/app/classes';
import * as moment from 'moment';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-notification-preview',
  templateUrl: './notification-preview.component.html',
  styleUrls: ['./notification-preview.component.css']
})
export class NotificationPreviewComponent implements OnInit {

  subject: string;
  subTitles: SubTitleWrapper[] = [];

  _notification: Notification;
  @Input() set notification(notification: Notification){
    this._notification = notification;
    if(notification){
      if(notification.notificationsubject) this.subject = notification.notificationsubject;
      if(notification.notificationtime) this.subTitles.push({
        "type": "Zeit",
        "value": moment(notification.notificationtime).format("DD.MM.YYYY HH:mm") + " Uhr"
      } as SubTitleWrapper);
      this.subTitles.push({ "type": "Sender", "value": "System" } as SubTitleWrapper);
      if(notification.notificationuser) {
        let user = this._dataService.users.find(x => x.id == notification.notificationuser);
        if(user) this.subTitles.push({
          "type": "Empfänger",
          "value": user.userName
        } as SubTitleWrapper);
      }
    }
  }
  get notification(): Notification {
    return this._notification;
  }

  constructor(
    private _dataService: DataService
  ) { }

  ngOnInit(): void {
  }

}
